import { connect } from 'react-redux';
import MobileNav from './MobileNav';
import { setMobileFilterDrawerOpen } from '../store/customerAuthorizationSlice';

const mapState = () => ({});

const mapDispatchToProps = { setMobileFilterDrawerOpen };

export default connect(mapState, mapDispatchToProps)(MobileNav);
